import { DataList as ChakraDataList } from '@chakra-ui/react';
import * as React from 'react';

import { InfoTip } from './toggle-tip';

export const DataListRoot = ChakraDataList.Root;

interface ItemProps extends ChakraDataList.ItemProps {
	grow?: boolean
	info?: React.ReactNode
	label: React.ReactNode
	value: React.ReactNode
}

export const DataListItem = React.forwardRef<HTMLDivElement, ItemProps>(function DataListItem(props, ref) {
	const {
		children, grow, info, label, value, ...rest
	} = props;

	return (
		<ChakraDataList.Item ref={ref} {...rest}>
			<ChakraDataList.ItemLabel flex={grow ? '1' : undefined}>
				{label}
				{info && (
					<InfoTip>
						{info}
					</InfoTip>
				)}
			</ChakraDataList.ItemLabel>
			<ChakraDataList.ItemValue flex={grow ? '1' : undefined}>
				{value}
			</ChakraDataList.ItemValue>
			{children}
		</ChakraDataList.Item>
	);
});
